import CryptoJS from "crypto-js";

export const formatIdWithPrefix = (id, prefix) => {
  return `${prefix}${String(id).padStart(3, "0")}`;
};

export const USER_TYPE_MAP = {
  1: "Admin",
  2: "Enterprise",
  3: "Merchant",
  4: "Super Agent",
  5: "Agent",
  6: "Customer",
};

export const USER_STATUS_MAP = {
  0: { label: "Suspended", color: "error" },
  1: { label: "Active", color: "success" },
};

export const KYC_STATUS_MAP = {
  PENDING: { label: "Pending", color: "warning" },
  "UNDER REVIEW": { label: "Under Review", color: "processing" },
  APPROVED: { label: "Approved", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
};

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const INIT_VECTOR = process.env.REACT_APP_INIT_VECTOR;

export const decryptData = (encrypted) => {
  try {
    if (!SECRET_KEY || !INIT_VECTOR) {
      throw new Error(
        "Missing SECRET_KEY or INIT_VECTOR in environment variables"
      );
    }

    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const iv = CryptoJS.enc.Utf8.parse(INIT_VECTOR);

    const bytes = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (e) {
    console.error("Decryption error", e);
    return null;
  }
};

export const encryptData = (data) => {
  try {
    if (!SECRET_KEY || !INIT_VECTOR) {
      throw new Error(
        "Missing SECRET_KEY or INIT_VECTOR in environment variables"
      );
    }

    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const iv = CryptoJS.enc.Utf8.parse(INIT_VECTOR);

    // Convert data (object) into string before encryption
    const stringData = JSON.stringify(data);

    const encrypted = CryptoJS.AES.encrypt(stringData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Base64 encoded string
  } catch (e) {
    console.error("Encryption error", e);
    return null;
  }
};

export const getCurrencySymbol = (nationality) => {
  if (!nationality) return "";

  const map = {
    indian: "₹",
    american: "$",
    canadian: "CA$",
    australian: "A$",
    british: "£",
    european: "€",
    japanese: "¥",
    chinese: "¥",
    singaporean: "S$",
    uae: "AED",
  };

  return map[nationality.toLowerCase()] || "$"; // default fallback
};

export const maskString = (
  str,
  visibleStart = 2,
  visibleEnd = 2,
  maskChar = "*"
) => {
  if (str == null) return "";
  const s = String(str);
  let vs = Math.max(0, visibleStart | 0);
  let ve = Math.max(0, visibleEnd | 0);
  const len = s.length;

  if (len === 0) return "";
  if (vs + ve >= len) return maskChar.repeat(len);

  const start = s.slice(0, vs);
  const end = ve > 0 ? s.slice(len - ve) : ""; // <-- key fix
  const masked = maskChar.repeat(len - vs - ve);

  return start + masked + end;
};

export const timeAgo = (date) => {
  const now = new Date();
  const past = new Date(date);
  const diffInSeconds = Math.floor((now - past) / 1000);

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  };

  for (const [unit, seconds] of Object.entries(intervals)) {
    const count = Math.floor(diffInSeconds / seconds);
    if (count > 0) {
      return `${count} ${unit}${count > 1 ? "s" : ""} ago`;
    }
  }

  return "just now";
};
